<template>
  <div>
    <a-form-model style="max-width: 500px;margin: 40px auto 0;">
      <a-result
        title="返回结果"
        status="success"
        subTitle="点击【返回房源列表】即可在列表中查看新添加的房源信息。"
      >
        <template slot="extra">
          <a-button type="primary" @click="finish">继续添加</a-button>
          <a-button style="margin-left: 8px" @click="toHouseList"
            >返回房源列表</a-button
          >
        </template>

        <div class="desc">
          <p style="font-size: 16px;">
            <strong>具体房源上传结果如下：</strong>
          </p>
          <p v-for="(item, idx) in result" :key="idx">
            <a-icon
              :style="{
                color:
                  item.code == 0 ? 'green' : item.code == 1 ? 'red' : 'orange'
              }"
              :type="
                item.code == 0
                  ? 'check-circle'
                  : item.code == 1
                  ? 'close-circle'
                  : 'exclamation-circle'
              "
            />
            <a>{{ item.houseName }}&gt;</a>
            <span
              :style="{
                color:
                  item.code == 0 ? 'green' : item.code == 1 ? 'red' : 'orange'
              }"
              >{{ item.message }}</span
            >
          </p>
        </div>
      </a-result>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: "Step3",
  props: {
    queryParam: {
      type: Object,
      default: function() {
        return {};
      }
    },
    result: {
      type: Object,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    finish() {
      this.$emit("finish");
    },
    toHouseList() {
      this.$router.push({
        name: "HouseList",
        query: { param: this.queryParam }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.desc p {
  margin-bottom: 1em;
}
</style>
